import { SquarePen, Trash, FileText } from "lucide-react";

export const FundsPlanTable = ({ fundsPlans, onEdit, onDelete }) => {
  return (
    <table className="w-full border-collapse">
      <thead>
        <tr className="bg-[#FFD4F4]">
          <th className="border px-4 py-3 text-left">Sponsor Name</th>
          <th className="border px-4 py-3 text-left">Sponsor's Amount (INR)</th>
          <th className="border px-4 py-3 text-left">
            Financial Institution's Country
          </th>
          <th className="border px-4 py-3 text-left">
            Name of Financial Institution
          </th>
          <th className="border px-4 py-3 text-left">Type of Funds</th>
          <th className="border px-4 py-3 text-left">6 Months Old Funds?</th>
          <th className="border px-4 py-3 text-left">Attachment</th>
          <th className="border px-4 py-3 text-left">Action</th>
        </tr>
      </thead>

      <tbody>
        {fundsPlans && fundsPlans.length > 0 ? (
          fundsPlans.map((f, index) => {
            const fileUrl =
              typeof f.proofOfFunds === "string"
                ? `${(process.env.REACT_APP_API_ENDPOINT || "")
                    .replace(/\/$/, "")
                    .replace(/\/api\/student$/, "")}${
                    f.proofOfFunds.startsWith("/")
                      ? f.proofOfFunds
                      : "/" + f.proofOfFunds
                  }`
                : f.proofOfFunds
                ? URL.createObjectURL(f.proofOfFunds)
                : null;

            return (
              <tr key={index} className="hover:bg-gray-50">
                <td className="border px-4 py-3">{f.sponsorName || "N/A"}</td>
                <td className="border px-4 py-3">
                  {Number(f.sponsorsAmount).toLocaleString("en-IN")}
                </td>
                <td className="border px-4 py-3">
                  {f.financialInstitutionCountry || "-"}
                </td>
                <td className="border px-4 py-3">
                  {f.financialInstitutionName || "-"}
                </td>
                <td className="border px-4 py-3">{f.typeOfFunds || "-"}</td>
                <td className="border px-4 py-3">
                  {f.oldFunds ? "Yes" : "No"}
                </td>

                {/* Attachment */}
                <td className="border px-4 py-3 text-center">
                  {fileUrl ? (
                    <a
                      href={fileUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-yellow-600 flex justify-center items-center hover:underline"
                    >
                      <FileText />
                    </a>
                  ) : (
                    "N/A"
                  )}
                </td>

                {/* Action buttons */}
                <td className="border px-4 py-3 flex gap-2 items-center justify-center">
                  <button
                    onClick={() => onEdit(index)}
                    className="text-blue-600 hover:underline"
                  >
                    <SquarePen />
                  </button>
                  <button
                    onClick={() => onDelete(index)}
                    className="text-red-600 hover:underline"
                  >
                    <Trash />
                  </button>
                </td>
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan="8" className="text-center py-4">
              No funds plan added yet.
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};
